<template>
  <div class="ba-relative" :class="{'ba-ml-20': queueType === 'параллельное'}">
    <div
      class="ba-text-black ba-bg-white ba-border ba-border-transparent ba-rounded"
      :class="{ 'ba-border-text-grey': isOpen }"
    >
      <vis-approval-queue-task-header
        :item="task"
        :queue-type="queueType"
        :expanded="isOpen"
        :progress-color="progressColor"
        :progress-width="progressWidth"
        :is-delegated="task.delegation"
        @click="toggle"
      />
      <div v-show="isOpen" class="ba-px-4">
        <div class="ba-pl-10">
          <vis-approval-queue-task-description
            :user="task.author"
            :date="task.startDate"
            :time="task.startTime"
            :description="task.description"
          />
          <vis-approval-queue-task-term
            :item="task.executionPeriod"
          />
          <vis-approval-queue-task-comments
            :comments="task.comments"
          />
        </div>
      </div>
    </div>
    <vis-approval-queue-task-delegation-panel
      v-if="task.delegation"
      :item="task"
      :queue-type="queueType"
      :is-delegated="task.delegation"
      :status-color="taskConnectionLineColor"
      :progress-color="progressColor"
      :progress-width="progressWidth"
    />
    <vis-approval-queue-task-connection-line
      :queue-type="queueType"
      :is-first="isFirst"
      :is-last="isLast"
      :color="taskConnectionLineColor"
    />
  </div>
</template>

<script>
import visApprovalQueueTaskHeader from "./vis-approval-queue-task-header";
import visApprovalQueueTaskDescription from "./vis-approval-queue-task-description";
import visApprovalQueueTaskTerm from "./vis-approval-queue-task-term";
import visApprovalQueueTaskComments from "./vis-approval-queue-task-comments";
import visApprovalQueueTaskDelegationPanel from "./vis-approval-queue-task-delegation-panel";
import visApprovalQueueTaskConnectionLine from "./vis-approval-queue-task-connection-line";

export default {
  name: "vis-approval-queue-task",
  components: {
    visApprovalQueueTaskHeader,
    visApprovalQueueTaskDescription,
    visApprovalQueueTaskTerm,
    visApprovalQueueTaskComments,
    visApprovalQueueTaskDelegationPanel,
    visApprovalQueueTaskConnectionLine,
  },
  props: {
    task: {
      type: Object,
      default: () => ({})
    },
    queueType: {
      type: String,
      default: null
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    taskConnectionLineColor: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
     progressWidth() {
      switch(this.task.progress) {
        case "до срока исполнения (Period.End) осталось > 30% времени":
          return "ba-w-1/3"
        case "до срока исполнения (Period.End) осталось от 10 до 30% времени":
          return "ba-w-3/4"
        case "до срока исполнения (Period.End) осталось < 10% времени":
          return "ba-w-11/12"
      }
      return null
    },
     progressColor() {
      switch(this.task.progress) {
        case "до срока исполнения (Period.End) осталось > 30% времени":
          return "ba-text-success-strong"
        case "до срока исполнения (Period.End) осталось от 10 до 30% времени":
          return "ba-text-warning"
        case "до срока исполнения (Period.End) осталось < 10% времени":
          return "ba-text-error-weak"
        default:
          return "ba-text-text-blue-grey"
      }
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>
